export default __webpack_public_path__ + "static/media/icon-users-solid.f6e262d0.svg";